import { rubriekenFp } from "domain/rubriek";
import { pipe } from "fp-ts/lib/function";
import { useAangifte } from "./AangifteProvider";

export const useRubriek = (code: string) => {
  const { aangifte } = useAangifte();

  return pipe(aangifte.rubrieken, rubriekenFp.lookup(code));
};
